import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardField from "./cardField";
import "../styles/stomach.css";
import CardOfField from "./cardOfField";

function Arrow(props) {
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";
  const char = props.type === "next" ? "➡" : "⬅";
  return (
    <span className={className} onClick={props.onClick}>
      {char}
    </span>
  );
}
export default class CarouselField extends Component {
  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      pauseOnHover: true,
      autoplay: true,
      autoplaySpeed: 1500,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows: true,
      appendDots: (dots) => (
        <div
          style={{
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      ),

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 9,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div id="programs">
        <div className="carouselTitle">Our Fields</div>

        <div className="container1">
          <Slider
            nextArrow={<Arrow type="next" />}
            prevArrow={<Arrow type="prev" />}
            {...settings}
          >
            <CardOfField
              title={"Electronics"}
              image={"./images/electronics.png"}
            />
            <CardOfField
              title={"Artificial intelligence"}
              image={"images/ai.jpg"}
            />
            <CardOfField
              title={"Internet Of Things"}
              image={"./images/iot.jpg"}
            />{" "}
            <CardOfField
              title={"Virtual Reality"}
              image={"./images/vr.jpg"}
            />
            <CardOfField
              title={"Robotics"}
              image={"./images/robotique.jpg"}
            />
            <CardOfField title={"Drones"} image={"./images/drones.jpg"} />{" "}
            <CardOfField
              title={"Coding"}
              image={"./images/coding.jpg"}
            />
            <CardOfField
              title={"Game development"}
              image={"./images/gamedev.jpg"}
            />
          </Slider>
        </div>
      </div>
    );
  }
}
